import { useAppConstantsContext } from '@/context/AppConstants';
import { Stack, Text, Button, Icons } from '@/theme/index';
import { publish } from '../../../events';

const SearchLogo = function SearchLogo() {
  const {
    images: { searchLogo },
  } = useAppConstantsContext();

  return (
    <picture style={{ display: 'inline-block' }}>
      <img src={searchLogo} alt="Search Logo" width={40} height={40} />
    </picture>
  );
};

export function PersonSearchNoResults() {
  const clickOnPeopleSearch = () => {
    publish('openPersonSearch');
  };

  return (
    <Stack
      spacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <SearchLogo />

      <Text variant="h5" fontWeight={400} display="inline-block">
        No results found try removing filters or try searching again
      </Text>

      <Button
        onClick={clickOnPeopleSearch}
        variant="contained"
        color="success"
        sx={{ width: '240px' }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Icons.Search fontSize="small" />
          <Text component="span">Search again</Text>
        </Stack>
      </Button>
    </Stack>
  );
}
